<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="输入标题进行检索" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="推送类型" prop="category">
                    <el-select v-model="query.category" placeholder="请选择推送类型">
                        <el-option label="邮箱" value="1" />
                        <el-option label="站内信" value="3" />
                    </el-select>
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('xxtz_xxlb_xz')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="标题" align="center" prop="title" />
                <el-table-column label="发布时间" align="center" prop="publish_time" />
                <el-table-column label="发布人" align="center" prop="admin.name" />
                <el-table-column label="推送类型" align="center" prop="category">
                    <template slot-scope="{ row }">
                        {{ { 1: "邮箱", 3: "站内信" }[row.category] }}
                    </template>
                </el-table-column>
                <el-table-column v-if="permission('xxtz_xxlb_ck') || permission('xxtz_xxlb_sc')" label="操作" align="center" width="100">
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('xxtz_xxlb_ck')" size="mini" type="text" @click="handleView(row)"> 查看 </el-button>
                        <el-button v-if="permission('xxtz_xxlb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <DialogVue ref="dialog"></DialogVue>
    </div>
</template>

<script>
import { list, del } from "@/api/msg/list";
import listMixin from "@/mixins/list";
import DialogVue from "./dialog.vue";

export default {
    components: { DialogVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                category: "",
            },
            module: "消息",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$refs.dialog.open();
        },
        handleView(row) {
            this.$router.push({ path: "/msg/list/detail", query: { cuuid: row.cuuid } });
        },
    },
};
</script>
